export const VISITOR_ID_HEADER = 'visitor-id';

export const VISITOR_ID_COOKIE = 'visitorId';

/** Upper limit is X days based on chrome limits: https://developer.chrome.com/blog/cookie-max-age-expires/ */
export const COOKIE_MAX_AGE = 60 * 60 * 24 * 400; // 400 days in seconds
